const DashboardCards = ({ itemName, itemValue, itemIcon, growth }) => {
  return (
    <div className="dashboardCardsInner">
      <div className="dashboardCardsCol">
        <div
          className={`dashboradCardContent ${itemName
            .toLowerCase()
            .replaceAll(" ", "")}`}
        >
          <p>{itemName}</p>
          <span className="cardValue">{itemValue}</span>
        </div>
        <div className="dashboradCardContent">
          <img src={itemIcon} alt="card icon" />
        </div>
      </div>
      {/* <div className="dashboardCardsCol">
        {growth?.show && (
          <span
            className="smallLightText"
            dangerouslySetInnerHTML={{ __html: growth.message }}
          />
        )}        
      </div> */}
    </div>
  );
};

export default DashboardCards;
